﻿import CarFinderNavigation from './comp/navigation';
import CarFinderRange from './comp/range';

class CarFinder {
    constructor(selector) {
        // set the store object where form data will be saved
        this.pageIndex = 0; // start at 0
        this.totalPages = 2; 
        this.formData = {};
        this.apiUrl = "/app/nz/api/carfinder/results";

        // call render function
        this.all = document.querySelectorAll(selector);
        if (this.all.length > 0) {
            this.render(this.all[0]);
        }
    }

    /**
     * Event handlers
     */
    onPrevPageClick() {
        this.pageTransition(this.pageIndex - 1);
    }

    onNextPageClick() {
        this.updateFormValues();
        this.pageTransition(this.pageIndex + 1);
    }

    onResetClick(event) {
        event.preventDefault();
        this.formData = {};
        this.pageTransition(0);
        $(window).trigger('RESET_COMPONENTS');

        var _allradio = document.querySelectorAll('input[type="radio"]');
        _allradio.forEach(function (e) {
            if (e.checked) {
                e.checked = false;
            }
        });
    }

    updateFormValues() {
        this.formData = {};       
        $.each(this.ranges, this.getRangeValues.bind(this));
    }   

    getRangeValues(index, element) {
        const el = $(element);
        const question = el.attr('data-question');
        const inputs = el.find('*[data-component="c-car-finder-range-input"]');
        this.formData[question] = $(inputs[0]).val();
    }

    handleResults(results) {
        if (results.featured) {
            this.renderResults($(this.resultsFeatured[0]), results.featured);
        }
        if (results.all) {
            this.renderResults($(this.resultsAll[0]), results.all);
        }
    }

    /**
     * Transition Animations
     * Call functions that need to be called when pages are entered
     */
    pageTransition(nextPage) {
        this.transitionPageOut(this.pageIndex);
        this.transitionPageIn(nextPage);
        this.triggerComponentUpdate(nextPage);
        this.pageIndex = nextPage;
        this.showHideElements();
        this.getResults();
        this.scrollToTopOfPage();
    }

    scrollToTopOfPage() {
        $('body,html').animate({
            scrollTop: 5
        },
            400, function () { }
        );
    }

    transitionPageOut(index) {
        const page = $(this.pages[index]);
        page.removeClass('active');
    }

    transitionPageIn(index) {
        const page = $(this.pages[index]);
        page.addClass('active');
    }

    triggerComponentUpdate(index) {
        const page = $(this.pages[index]);
        const ranges = page.find('*[data-component="c-car-finder-range"]');
        ranges.trigger('NAVIGATION_IN');
    }

    showHideElements() {
        // results page show/hide       
        if (this.pageIndex === this.totalPages) {            
            setTimeout(() => {
                this.formContainer.hide();
                this.resultsContainer.show();
            }, 1000);
        } else {
            this.formContainer.show();
            this.resultsContainer.hide();
        }
    }

    showLoading(loading) {
        if (loading) {
            this.loader.addClass('active');
        } else {
            this.loader.removeClass('active');
        }
    }

    /**
     * API Calls
     */
    getResults() {

        if (this.pageIndex === this.totalPages) {
            this.showLoading(true);

            var _ele = document.querySelector('input[type="hidden"][name="finalAnswers"]');
            var _dataStr = $(_ele).attr("data-answers");
            var myObject = JSON.parse(_dataStr);

            this.answersData = {
                question1: myObject.qAttrs,
                question2: myObject.qPeople, // people
                question3: myObject.qSpace, // space
                question4: myObject.qDrive, // drive
                question5: this.formData.question5,   //price
                question6: myObject.qEngine   // engine
            };

            //console.log(this.answersData);

            $.ajax(this.apiUrl, {
                method: 'post',
                data: this.answersData,
                dataType: "json"
            })
                .done(results => {
                    setTimeout(() => {
                        this.handleResults(results);
                        this.showLoading(false);
                    }, 2000);
                })
                .fail(error => {
                    this.showLoading(false);
                    console.error(error);
                })
        }
    }


    /**
     * Render component
     */
    render(el, index) {
        this.events = {
            CAR_FINDER_PREV_PAGE: 'CAR_FINDER_PREV_PAGE',
            CAR_FINDER_NEXT_PAGE: 'CAR_FINDER_NEXT_PAGE',
        };

        // Find child components
        this.element = $(el);
        this.formContainer = this.element.find('*[data-component="c-car-finder-layout-form"]');
        this.resultsContainer = this.element.find('*[data-component="c-car-finder-layout-results"]');      
        this.pages = this.element.find('*[data-component="c-car-finder-page"]');
        this.navigation = this.element.find('*[data-component="c-car-finder-nav-button"]');        
        this.ranges = this.element.find('*[data-component="c-car-finder-range"]');
        this.restartButton = this.element.find('*[data-component="c-car-finder-restart"]');               
        this.resultsFeatured = this.element.find('*[data-component="c-car-finder-results-featured"]');
        this.resultsAll = this.element.find('*[data-component="c-car-finder-results-all"]');
        this.loader = this.element.find('*[data-component="c-car-finder-loading"]');

        // Set initail view state
        $.each(this.pages, (index, page) => {
            if (index === this.pageIndex) {
                this.transitionPageIn(index);
            }
        });

        this.showHideElements();
        this.getResults();


        // Handle element events
        this.restartButton.on("click", this.onResetClick.bind(this));

        // Handle child component events
        this.navigation.on(this.events.CAR_FINDER_PREV_PAGE, this.onPrevPageClick.bind(this));
        this.navigation.on(this.events.CAR_FINDER_NEXT_PAGE, this.onNextPageClick.bind(this));
    }

    renderResults(el, model) {
        el.empty();
        for (let index = 0; index < model.length; index++) {
            el.append(this.renderResult(model[index]));
        }

    }

    renderResult(model) {
        return `<div class="c-car-finder-results__panels__panel">
        <div class="c-car-finder-results__panels__panel__image">
            <img src="${model.image}" alt="${model.name}" />
        </div>

        <div class="c-car-finder-results__panels__panel__body" style="background:${model.bg_color}">
            <h3 style="color:${model.text_color}">${model.name}</h3>            
        </div>

        <div class="c-car-finder-results__panels__panel__footer">
            <div class="c-car-finder-results__panels__panel__body__paragraph">
              ${model.description}
            </div>
            <a href="${model.product_url}" class="StyledLinkText">Explore</a>
            <a href="${model.dealer_url}" class="StyledLinkText">Find a Dealer</a>
        </div>
    </div>`;
    }

}

export default CarFinder;
